import { PrismicNextImage } from '@prismicio/next';
import { asText, Content, isFilled } from '@prismicio/client';

import { Box, Heading } from '@preventx/oxygen';
import { RichText } from '@preventx/prismic-services';

// Services
import { applicationEnv } from '@/services/env/shared';

// Components
import { Link } from '@/components/Actions/Link';

type WithImageProps = {
  slice: Content.RegionSliceWithImage;
};

export const WithImage = ({ slice }: WithImageProps) => {
  const { primary } = slice;
  const { title, content, image, link, image_position, image_caption } =
    primary;

  const { WebsiteUrl } = applicationEnv();

  return (
    <Box component="div" addSwitcher>
      {image_position === 'Left' && (
        <figure className="align-center">
          <PrismicNextImage field={image} className="rounded-lg" />

          {isFilled.richText(image_caption) && (
            <figcaption>
              <RichText
                variant="default"
                content={image_caption}
                websiteUrl={WebsiteUrl}
              />
            </figcaption>
          )}
        </figure>
      )}

      <Box component="div" addFlow>
        <Heading component="h2" addHeadlineTitle>
          {asText(title)}
        </Heading>

        <RichText content={content} variant="default" websiteUrl={WebsiteUrl} />

        {isFilled.link(link) && (
          <Link
            href={link}
            as="default"
            type="button"
            variant="solid"
            colour="primary"
            retainSearchParams
          >
            {link.text}
          </Link>
        )}
      </Box>

      {image_position === 'Right' && (
        <figure className="align-center">
          <PrismicNextImage field={image} className="rounded-lg" />

          {isFilled.richText(image_caption) && (
            <figcaption>
              <RichText
                variant="default"
                content={image_caption}
                websiteUrl={WebsiteUrl}
              />
            </figcaption>
          )}
        </figure>
      )}
    </Box>
  );
};
